import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    title: String,
    link: String,
    image: String
  }

  shareOnFacebook(e) {
    e.preventDefault()

    if (window.trackingEvent) {
      window.trackingEvent.share({
        method: 'facebook',
        content_type: 'campaign',
        item_id: this.linkValue,
      })
    }

    if (typeof FB !== 'undefined') {
      FB.ui({
        method: "share",
        href: this.linkValue,
      })
    }
  }

  shareOnTwitter(e) {
    e.preventDefault()

    if (window.trackingEvent) {
      window.trackingEvent.share({
        method: 'twitter',
        content_type: 'campaign',
        item_id: this.linkValue,
      })
    }

    window.open(
      `https://twitter.com/share?url=${encodeURIComponent(this.linkValue)}&text=${encodeURIComponent(this.titleValue)}`,
      "_blank"
    )
  }

  shareOnReddit(e) {
    e.preventDefault()

    if (window.trackingEvent) {
      window.trackingEvent.share({
        method: 'reddit',
        content_type: 'campaign',
        item_id: this.linkValue,
      })
    }

    window.open(
      `https://reddit.com/submit?url=${encodeURIComponent(this.linkValue)}&title=${encodeURIComponent(this.titleValue)}`,
      "_blank"
    )
  }

  shareOnPinterest(e) {
    e.preventDefault()

    if (window.trackingEvent) {
      window.trackingEvent.share({
        method: 'pinterest',
        content_type: 'campaign',
        item_id: this.linkValue,
      })
    }

    window.open(
      `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(this.linkValue)}&media=${encodeURIComponent(this.imageValue)}&description=${encodeURIComponent(this.titleValue)}`,
      "_blank"
    )
  }

  shareOnWhatsapp(e) {
    e.preventDefault()

    if (window.trackingEvent) {
      window.trackingEvent.share({
        method: 'whatsapp',
        content_type: 'campaign',
        item_id: this.linkValue,
      })
    }

    // 修正原有的錯誤，使用正確的變數
    window.location.href = `https://api.whatsapp.com/send?text=${encodeURIComponent(this.linkValue)}`
  }


  copyLink(e) {
    e.preventDefault()

    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.linkValue)
    }

    const tooltipElement = e.target.querySelector('.campaign-share-tooltip')
    if (tooltipElement) {
      tooltipElement.style.visibility = "visible"
      setTimeout(function () {
        tooltipElement.style.visibility = "hidden"
      }, 1000)
    }
  }
}